// extracted by mini-css-extract-plugin
var _1 = "ButtonCourse_button__7b107";
var _2 = "ButtonCourse_content__2ab53";
var _3 = "ButtonCourse_disabled__a5c7b";
var _4 = "ButtonCourse_fluid__56063";
var _5 = "ButtonCourse_ghost__d9b85";
var _6 = "ButtonCourse_icon-large__3c12e";
var _7 = "ButtonCourse_icon-medium__0a721";
var _8 = "ButtonCourse_icon-mini__d4e29";
var _9 = "ButtonCourse_icon-xmini__477a3";
var _a = "ButtonCourse_inheritColor__b320e";
var _b = "ButtonCourse_large__90ac3";
var _c = "ButtonCourse_medium__33baf";
var _d = "ButtonCourse_mini__9a33b";
var _e = "ButtonCourse_primary__3389e";
var _f = "ButtonCourse_round__173bf";
var _10 = "ButtonCourse_rounded__8e3ed";
var _11 = "ButtonCourse_xmini__3a7d5";
export { _1 as "button", _2 as "content", _3 as "disabled", _4 as "fluid", _5 as "ghost", _6 as "icon-large", _7 as "icon-medium", _8 as "icon-mini", _9 as "icon-xmini", _a as "inheritColor", _b as "large", _c as "medium", _d as "mini", _e as "primary", _f as "round", _10 as "rounded", _11 as "xmini" }
